// cardReducer.js
import {
  CARD_FETCHING,
  CARD_FETCH_SUCCESS,
  CARD_FETCH_FAILED,
  SET_DEFAULT_CARD_LOADING,
  SET_DEFAULT_CARD_SUCCESS,
  SET_DEFAULT_CARD_FAILED,
} from '../actions/types';

const initialState = {
  loading: false,
  settingDefault: false,
  error: false,
  errorMessage: '',
  cards: [],
  customer: {},
  defaultPaymentMethodId: null,
};

export default function cardReducer(state = initialState, action) {
  switch (action.type) {
    case CARD_FETCHING:
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: '',
      };

    case CARD_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: '',
        cards: action.payload.cards,
        customer: action.payload.customer,
        defaultPaymentMethodId: action.payload.defaultPaymentMethodId,
      };

    case CARD_FETCH_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload || 'Failed to fetch cards.',
        cards: [],
        customer: {},
      };

    case SET_DEFAULT_CARD_LOADING:
      return {
        ...state,
        settingDefault: true,
        error: false,
        errorMessage: '',
      };

    case SET_DEFAULT_CARD_SUCCESS:
      return {
        ...state,
        settingDefault: false,
        error: false,
        errorMessage: '',
        defaultPaymentMethodId: action.payload.defaultPaymentMethodId,
      };

    case SET_DEFAULT_CARD_FAILED:
      return {
        ...state,
        settingDefault: false,
        error: true,
        errorMessage: action.payload || 'Failed to set default card.',
      };

    default:
      return state;
  }
}
